/**
 * Test IDs for QA automation.
 */
export const testIds = {
  referenceNumberFormDefaultReferenceNumber: "reference-number-form-default-reference-number",
} as const;
